/**
 * Shared color/label helpers used by both `QuestionListPanel` (list rows) and
 * `QuestionDetailPanel` (read-only detail view). Extracted from
 * `QuestionsPage.tsx` during the 2026-05-17 split-pane refactor so the
 * panels can live in their own files without duplicating these.
 */
import { READINESS_LABELS } from '../question-set-types';

export function getDifficultyColor(difficulty: string): string {
    switch (difficulty) {
        case 'easy': return '#22c55e';
        case 'medium': return '#f59e0b';
        case 'hard': return '#ef4444';
        default: return '#6b7280';
    }
}

export function getQuestionTypeColor(type: string | undefined): string {
    switch (type) {
        case 'MCQ': return '#8b5cf6';
        case 'NUMERICAL': return '#0891b2';
        case 'FREEFORM': return '#64748b';
        case 'SINGLELINE': return '#059669';
        default: return '#64748b';
    }
}

export function getEnrichStatusColor(status: number | undefined): string {
    switch (status ?? 0) {
        case 0: return '#9ca3af';
        case 1: return '#f59e0b';
        case 2: return '#3b82f6';
        case 3: return '#22c55e';
        default: return '#9ca3af';
    }
}

export function getReadinessColor(readiness: number | null | undefined): string {
    const v = readiness ?? 0;
    if (v === -1) return '#7f1d1d';
    if (v <= 10) return '#ef4444';
    if (v <= 20) return '#f97316';
    if (v <= 30) return '#eab308';
    if (v <= 40) return '#22c55e';
    return '#15803d';
}

export function getReadinessLabel(readiness: number | null | undefined): string {
    const v = readiness ?? 0;
    return READINESS_LABELS[v] || `Readiness ${v}`;
}

export function getDifficulty(question: { difficulty?: string; difficultyLevel?: string }): string {
    return question.difficulty || question.difficultyLevel || 'medium';
}

export function getExamBadgeText(
    question: { appearedInExams?: { exam: string; date?: string }[] | null },
): string | null {
    if (!question.appearedInExams || question.appearedInExams.length === 0) return null;
    const first = question.appearedInExams[0];
    const year = first.date ? new Date(first.date).getFullYear() : null;
    return year ? `${first.exam} ${year}` : first.exam;
}
